import React, { useState, useEffect } from "react";
import { addToCart } from "../../api/cartApi";
import { getProducts } from "../../api/productApi";
import { CiShop } from "react-icons/ci";
import { IoBagHandleOutline } from "react-icons/io5";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import { FaCircle } from "react-icons/fa";
import { IoEyeOutline } from "react-icons/io5";
import { BsFillBagFill } from "react-icons/bs";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const initialProducts = [];
const CardList = () => {
  const [products, setProducts] = useState(initialProducts);
  const [loading, setLoading] = useState(false);
  const [priceRange, setPriceRange] = useState({ low: 0, high: 0 });
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const priceOptions = [
    { label: "All Prices", low: 0, high: 0 },
    { label: "$0 - $50", low: 0, high: 50 },
    { label: "$50 - $100", low: 50, high: 100 },
    { label: "$100 - $200", low: 100, high: 200 },
    { label: "$200 - $500", low: 200, high: 500 },
  ];
  // Add these near your other state declarations
  const [sortBy, setSortBy] = useState("newest");
  const [ratingRange, setRatingRange] = useState({ min: 0, max: 5 });

  // Add sorting options constant
  const sortOptions = [
    { value: "newest", label: "Newest First" },
    { value: "price_low_high", label: "Price: Low to High" },
    { value: "price_high_low", label: "Price: High to Low" },
    { value: "popularity", label: "Popularity" },
    { value: "rating", label: "Rating" },
  ];

  // Update the fetchProducts function
  const fetchProducts = async (low, high) => {
    try {
      setLoading(true);
      setError(null);

      const token =
        sessionStorage.getItem("accessToken") ||
        localStorage.getItem("accessToken") ||
        "";

      if (!token) {
        setError("Authentication token missing. Please log in.");
        setLoading(false);
        return;
      }

      // Construct filters object based on conditions
      let filters = {};

      // Add price range if present
      if (low && high) {
        filters.lowestprice = low;
        filters.highestprice = high;
      }

      // Add sorting
      if (sortBy) {
        filters.sortBy = sortBy;

        // Add rating range if sorting by rating
        if (sortBy === "rating") {
          filters.rating = {
            min: ratingRange.min,
            max: ratingRange.max,
          };
        }
      }

      const body = {
        filters,
        page: 1,
        limit: 10,
      };

      const res = await axios.post(
        `${API_BASE_URL}/buyer/get-products`,
        body,
        {
          headers: {
            token,
            "Content-Type": "application/json",
          },
        }
      );

      if (res?.data?.success) {
        const list = res?.data?.result?.products || [];
        const mapped = list.map((p) => ({
          id: p.id,
          name: p.product_name,
          image:
            p.product_media?.[0]?.url ||
            "https://via.placeholder.com/150?text=No+Image",
          originalPrice: parseFloat(p.product_price).toFixed(2),
          discountedPrice: parseFloat(p.discount_price).toFixed(2),
          offerPercentage: parseFloat(p.offer_percentage),
          inStock: p.inStock,
          rating: p.avg_rating || 0,
          totalRatings: p.total_ratings || 0,
        }));
        console.log("Fetched products:", mapped);
        setProducts(mapped);
      } else {
        setProducts([]);
        setError(res?.data?.message || "Failed to load products");
      }
    } catch (err) {
      console.error("Error fetching products:", err);
      setError("Error fetching products");
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };

  // Update useEffect to include sortBy dependency
  useEffect(() => {
    fetchProducts(priceRange.low, priceRange.high);
  }, [priceRange, sortBy]); // Add sortBy to dependencies

  // Update the JSX where you have the selects

  function mapApiProduct(p) {
    const originalPrice = Number(p.product_price) || 0;
    const discountedPrice = Number(p.discount_price) || 0;
    const offerPercentage =
      p.offer_percentage !== undefined
        ? Number(p.offer_percentage)
        : originalPrice
        ? Math.round(((originalPrice - discountedPrice) / originalPrice) * 100)
        : 0;

    return {
      id: p.id,
      name: p.product_name || p.title || "Untitled",
      image:
        (p.product_media && p.product_media[0] && p.product_media[0].url) ||
        "/image/shoeimg.png",
      originalPrice: originalPrice.toFixed
        ? originalPrice.toFixed(2)
        : String(originalPrice),
      discountedPrice: discountedPrice.toFixed
        ? discountedPrice.toFixed(2)
        : String(discountedPrice),
      offerPercentage,
      inStock: p.inStock !== undefined ? p.inStock : p.product_qty > 0,
      raw: p,
      sellername: p.seller?.name || "Unknown Seller", // ✅ Get seller name dynamically
    };
  }

  useEffect(() => {
    let mounted = true;
    async function load() {
      setLoading(true);
      try {
        const res = await getProducts({}, 1, 20);
        // Primary expected shape: res.result.products
        const apiList =
          res?.result?.products ||
          res?.result?.Products ||
          res?.products ||
          res?.data?.products ||
          res?.data ||
          res;
        if (mounted && Array.isArray(apiList) && apiList.length > 0) {
          const mapped = apiList.map(mapApiProduct);
          setProducts(mapped);
        }
        // otherwise keep the initialProducts fallback
      } catch (err) {
        // keep fallback products on error
        console.error("getProducts failed:", err);
      } finally {
        if (mounted) setLoading(false);
      }
    }

    load();
    return () => {
      mounted = false;
    };
  }, []);
  // 🔹 Handle navigation to ProductView
  
  const handleBuyNow = (productId) => {
   navigate(`/ProductView/${productId}`, {
      state: { productId },
    });
    console.log("productId",productId)
  };

  

  return (
    <div>
      <div className="flex  justify-between items-center mt-10">
        {/* Left: Search */}
        <div className="flex items-center gap-2 w-full max-w-md">
          <select
            className="border-2 py-1 px-3 rounded-2xl"
            onChange={(e) => {
              const selected = priceOptions[e.target.selectedIndex];
              setPriceRange({ low: selected.low, high: selected.high });
            }}
          >
            {priceOptions.map((opt, idx) => (
              <option key={idx} value={idx}>
                {opt.label}
              </option>
            ))}
          </select>

          {/* Sort By Select */}
          <select
            className="border-2 py-1 px-3 rounded-2xl"
            value={sortBy}
            onChange={(e) => {
              const newSortBy = e.target.value;
              setSortBy(newSortBy);

              // If rating is selected, show rating range options
              if (newSortBy === "rating") {
                setRatingRange({ min: 3, max: 5 }); // Default rating range
              }
            }}
          >
            {sortOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>

          {/* Conditional Rating Range Select */}
          {sortBy === "rating" && (
            <select
              className="border-2 py-1 px-3 rounded-2xl"
              value={`${ratingRange.min}-${ratingRange.max}`}
              onChange={(e) => {
                const [min, max] = e.target.value.split("-").map(Number);
                setRatingRange({ min, max });
              }}
            >
              <option value="3-5">3+ Stars</option>
              <option value="4-5">4+ Stars</option>
              <option value="5-5">5 Stars Only</option>
            </select>
          )}
        </div>
      </div>
      <div className="w-[100%] flex  gap-3">
        <div className="w-[65%] ">
          {/* Right: Profile & Cart */}
          {/* <div className="flex items-center gap-4">
            <div className="flex justify-between items-center">
              <button
                  className="flex gap-2  items-center text-white rounded-xl text-xs mt-2 px-5 py-2"
                  style={{
                    background:
                      "linear-gradient(266.95deg, #1DE78B 2.65%, #08AEEA 97.47%)",
                  }}
                >
                  <CiShop className="text-[23px] " />{" "}
                  <span className="text-[18px]">View Seller Profile</span>
                </button>
            </div>
          </div> */}

          <div className="mt-8">
            <div className="grid grid-cols-3 gap-4">
              {loading ? (
                <div className="col-span-3 p-4 text-center">
                  Loading products...
                </div>
              ) : error ? (
                <div className="col-span-3 p-4 text-red-600 text-center">
                  {error}
                </div>
              ) : products.length === 0 ? (
                <div className="col-span-3 p-4 text-center">
                  No products found in this range.
                </div>
              ) : (
                products.map((product) => (
                  <div
                    key={product.id}
                    className="border rounded-md p-2 bg-white flex flex-col shadow-sm hover:shadow-md transition-all"
                  >
                    <div
                      className="bg-[#eceef0] relative rounded-xl cursor-pointer"
                      onClick={() => handleBuyNow(product.id)}
                    >
                      {product.offerPercentage > 0 && (
                        <p className="absolute top-1 left-1 px-3 py-1 rounded-tl-3xl rounded-br-3xl bg-red-700 text-white text-xs font-semibold">
                          {product.offerPercentage}% OFF
                        </p>
                      )}
                      <img
                        src={product.image}
                        alt={product.name}
                        className="w-full h-48 object-contain rounded-xl"
                      />
                    </div>
                    {/* ✅ Seller name */}
                    <div className="mt-2">
                      <div className="inline-flex px-2 py-1 rounded-xl gap-1 items-center border-[1px] border-[#08AEEA] ">
                        <img
                          src="/image/wanchain.png"
                          alt=""
                          className="w-4 h-4"
                        />
                        <h4 className="text-[10px] font-bold">
                          {product.sellername}
                          {/* {product.id} */}
                        </h4>
                      </div>
                    </div>

                    <div className="space-y-1">
                      <h4 className="text-[13px] font-bold">{product.name}</h4>

                      <p className="text-xs font-semibold line-through text-gray-400">
                        ${product.originalPrice}
                      </p>
                      <div className="flex justify-between items-center">
                        <p className="text-[15px] font-bold text-[#095228]">
                          ${product.discountedPrice}
                        </p>
                        {/* <span className="text-xs text-gray-500">
                          {product.offerPercentage}% Offer
                        </span> */}
                        <button
                          className="flex gap-2 items-center bg-[#161F28] text-white rounded-xl text-xs  p-2"
                          onClick={async () => {
                            try {
                              const res = await addToCart(product.id, 1, 0);
                              alert(res.message || "Added to cart");
                              window.location.reload();
                            } catch (err) {
                              alert("Failed to add to cart");
                            }
                          }}
                        >
                          <IoBagHandleOutline className="text-[14px]" />{" "}
                          <span className="text-[10px]">ADD TO CART</span>
                        </button>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
        <div className="w-[35%]">
          <ProductLiveCard />
        </div>
      </div>
    </div>
  );
};

export default CardList;

function ProductLiveCard() {
  return (
    <div className=" relative w-full h-[250px] bg-[#FEFDEB] mt-10 rounded-2xl shadow-lg  overflow-hidden border border-gray-200">
      {/* Live Banner Image */}
      <div>
        <div className="relative">
          <img
            src="https://images.unsplash.com/photo-1524592094714-0f0654e20314?q=80&w=600" // replace with your image
            alt="Live Stream"
            className="w-full h-40 object-cover"
          />

          {/* Top Info Bar */}
          <div className="absolute top-0 left-0 text-white text-xs font-semibold  ">
            <div className="flex gap-3 p-2 bg-[#D9D9D980] rounded-br-3xl">
              <div className="bg-white p-2 w-[30px] h-[30px] rounded-full">
                <img
                  src="/image/wanchain.png"
                  alt="logo"
                  className="w-[20px] h-[20px] object-contain"
                />
              </div>
              <div className="text-black">
                <p className="font-semibold text-[12px]">SKY Products</p>
                <p className="text-[9px]">27 Jan 2025, 12:30 PM</p>
              </div>
            </div>
            <p className="ml-5 mt-2"> 100K Viewers</p>
          </div>

          <div className="absolute top-2 right-2 bg-red-600 text-white text-xs font-semibold px-3 py-1 rounded-full">
            LIVE
          </div>

          {/* Viewers */}
          {/* <div className="absolute bottom-2 left-2 flex items-center gap-2 bg-black/50 backdrop-blur-sm px-2 py-1 rounded-full text-white text-xs">
          <IoEyeOutline className="text-sm" />
          100K Viewers
        </div> */}
        </div>
      </div>
      {/* Product Section */}

      <div className="absolute bottom-0 left-9">
        <div className="border rounded-md p-2  w-[320px] h-[120px] bg-white flex  justify-center shadow-sm hover:shadow-md transition-all">
          {/* Product Image Section */}
          <div className="bg-[#eceef0] w-[40%] relative rounded-xl cursor-pointer flex items-center justify-center overflow-hidden">
            <p className="absolute top-1 left-1 px-3 py-1 rounded-tl-3xl rounded-br-3xl bg-red-700 text-white text-[10px] font-semibold">
              20% OFF
            </p>
            <img
              src={"/image/shoeimg.png"}
              alt={""}
              className="w-full h-full object-contain rounded-xl"
            />
          </div>

          {/* Product Details Section */}
          <div className="w-[60%] flex flex-col justify-between pl-2">
            <div className="space-y-1">
              <h4 className="text-[16px] font-bold line-clamp-1 ">
                ADIDAS 4DFWD X PARLEY RUNNING SHOES....
              </h4>

              <p className="text-[14px] font-bold  text-[#095228]">$ 333.20 </p>

              <div className="flex gap-2 items-center">
                <button className="flex gap-1items-center bg-[#095228] text-white rounded-xl text-[10px] px-2 py-2 hover:opacity-90 transition-all">
                  <IoBagHandleOutline className="text-[14px]" />
                  <span>ADD TO CART</span>
                </button>
                <p className=" text-[12px] p-1 rounded-xl bg-[#98911F]">
                  01:00:00
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
